import { render } from "./CompetencePanel.vue?vue&type=template&id=5f6eb024"
import script from "./CompetencePanel.vue?vue&type=script&lang=js"
export * from "./CompetencePanel.vue?vue&type=script&lang=js"

import "./CompetencePanel.vue?vue&type=style&index=0&id=5f6eb024&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__